import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { Estate } from './estate';

type PublishEstateOptions = {
  mutationConfig?: MutationConfig<typeof publishEstate>;
};

const publishEstate = (id: Estate['id']) => {
  return extractData(api.estates({ id }).publish.put());
};

export const usePublishEstate = ({ mutationConfig }: PublishEstateOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: publishEstate,
  });
};
